import { useEffect, useState } from "react"
import { getModeloById, postModelo, patchModelo } from "../../services/ModelosServices"
import { ModelosFormContext } from "./ModelosContext"
import { useNavigate, useParams } from 'react-router-dom';
//import { Modelos } from '../../routes/RoutesConstants'

export const ModelosFormState = ({ children }) => {
    const [report, setReport] = useState({})
    const navigate = useNavigate();
    const { id } = useParams()

    useEffect(() => {
        if (id) getModeloByIdData(id)
    }, [])

    const getModeloByIdData = async (id) => {
        let res = await getModeloById(id)
        if (res) setReport(res)
    }

    const postModeloData = async (body) => {
        const res = await postModelo(body)
        
        if (res) navigate("/Modelos");
    }

    const patchModeloData = async (id, body) => {
        const res = await patchModelo(id, body)

        if (res) navigate("/Modelos");
    }


    return <ModelosFormContext.Provider value={{
        report,
        postModeloData,
        patchModeloData,
    }} >
        {children}
    </ModelosFormContext.Provider>
}